// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialEditor-cls1_vKi","cls2":"SocialEditor-cls2_-jw SocialEditor-cls1_vKi"};